import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import DefaultLayout from "./Layout/DefaultLayout";
import ShareWindowHeader from "./Pages/BoardMain";
import Dashboard from "./Pages/Dashboard";
import BoardMain from "./Pages/BoardMain";

const AppRouter = () => {
  const [loading, setLoading] = useState(false);
  const userData = useSelector((state) => state.user);
  const groupId = userData?.user?.group?.uuid;

  return (
    <>
      <Routes>
        <Route
          path="/dashboard"
          element={
            <DefaultLayout>
              {" "}
              <Dashboard />{" "}
            </DefaultLayout>
          }
        />
        <Route path="/board/:type/:id" element={<BoardMain />} />\
        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Routes>
    </>
  );
};

export default AppRouter;
